module.exports = __webpack_public_path__ + "static/media/045-man-12.ca044aa6.svg";